




























































































































































































































































































































































































































































































































































































































































































































import _, { debounce } from 'lodash';
import {
  DownloadIcon,
  ShareIcon,
  EllipsisIcon,
  ChevronDownIcon,
  InfoCircleIcon,
  StarIcon,
  StarFilledIcon,
} from 'tdesign-icons-vue';
import {
  defineComponent,
  ref,
  toRefs,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  watch,
  onUnmounted,
  unref,
  onMounted,
} from '@vue/composition-api';
import { Route } from 'vue-router';

// 引入组件
import createFolderDialog from '@/renderer/components/dialog/createFolder.vue';
import renameFolderDialog from '@/renderer/components/dialog/rename.vue';
import selectTargetFolder from '@/renderer/components/dialog/selectTargetFolder/index.vue';
import dropdown from '@/renderer/components/dropdown/dropdown.vue';
import conflictDialog from '@/renderer/components/dialog/conflict.vue';
import errListDialog from '@/renderer/components/dialog/errList.vue';
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import CreateDocumentDialog from '@/renderer/components/dialog/createDocument.vue';
import LinkShare from '@/renderer/components/dialog/linkShare/index.vue';
import WemeetLinkShare from '@/renderer/components/dialog/linkShare/WemeetShare.vue';
import DropFile from '@/renderer/components/DropFile.vue';
import pullUpLoading from '@/renderer/components/dialog/pullUpLoading.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import Breadcrumb from '@/renderer/components/SpacePage/components/Breadcrumb.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import FileCollectResultDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectResultDialog.vue';
import FileCollectFormDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectFormDialog.vue';

import FileItem from '@/renderer/components/file/FileItem.vue';
import FileApplyDialog from '@/renderer/components/dialog/FileApply/components/FileApplyDialog.vue';
import FunctionBox from '@/renderer/components/SpacePage/components/FunctionBox.vue';
import SelectFolder from '@/renderer/views/desktop/FileManagement/FileSync/components/SelectFolder/SelectFolder.vue';
import SelectFilePath from '@/renderer/components/dialog/SelectFilePath/index.vue';

// 引入 compositions
import listOperateHandler, { DroppableStatus } from '@/renderer/scripts/composition/listOperateHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import listHandler from '@/renderer/components/SpacePage/compositions/listHandler';
import createHandler from '@/renderer/components/SpacePage/compositions/createHandler';
import renameHandler from '@/renderer/components/SpacePage/compositions/renameHandler';
import moveHandler from '@/renderer/components/SpacePage/compositions/moveHandler';
import copyHandler from '@/renderer/components/SpacePage/compositions/copyHandler';
import deleteHandler from '@/renderer/components/SpacePage/compositions/deleteHandler';
import detailHandler from '@/renderer/components/SpacePage/compositions/detailHandler';
import authHandler, { ConfirmAuthParams } from '@/renderer/components/SpacePage/compositions/authHandler';
import searchHandler from '@/renderer/scripts/composition/searchHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import linkShareHandler from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import extraFileInfoHandler from '@/renderer/components/SpacePage/compositions/extraFileInfoHandler';
import spaceQuotaHandler from '@/renderer/components/SpacePage/compositions/spaceQuotaHandler';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import guideStepHandler from '@/renderer/components/GuideAndHelp/composition/guideStepHandler';
import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';
import fileCollectDialogHandler from '@/renderer/components/dialog/FileCollect/composition/fileCollectDialogHandler';
import uploadHandler from '@/renderer/components/SpacePage/compositions/uploadHandler/index';
import downloadCodeHandler from '@/renderer/scripts/composition/downloadCode';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
import useFunctionBox from '@/renderer/components/SpacePage/compositions/useFunctionBox';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { can, optAuth, canBatch, operateType } from '@/renderer/scripts/composition/authHandler';
import { dragFileHandler } from '@/renderer/components/SpacePage/compositions/dragFileHandler';
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import hotkeyDataHelper, { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import storage from '@/renderer/scripts/utils/storage';
import store from '@/renderer/store';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import { LOCATION_MAP } from '@/common/reporter/utils';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import { checkVirusStatus } from '@/renderer/scripts/utils/checkVirusStatus';
import { actionHandler } from '@/renderer/components/SpacePage/compositions/actionHandler';
import { IS_PRIVATE, IS_BROWSER } from '@/common/constant';
import useSelectFolderHandler, {
  SyncSelectFolder,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/SelectFolderHandler';
import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { ShowConfigDialogSource } from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';

export interface CrumbItem {
  name: string;
  content: string;
  type: string;
  path: string | undefined;
  disabled: boolean;
}
export default defineComponent({
  name: 'SpacePageList',
  props: {
    spaceId: {
      type: String,
      default: '',
    },
    teamId: {
      type: Number,
      default: -1,
    },
    teamName: {
      type: String,
    },
    // 是否展示上方空间不足提示（个人空间、企业空间需要展示）
    showQuotaBar: {
      type: Boolean,
      default: false,
    },
    isPullListOnSetup: {
      type: Boolean,
      default: false,
    },
    // 与我相关里协作群组相关的文件，共享全部禁用
    isCospace: {
      type: Boolean,
      default: false,
    },
    // 是否为外部群组
    isExternGroup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileItem,
    FileApplyDialog,
    StatusTag,
    DownloadIcon,
    ShareIcon,
    ChevronDownIcon,
    InfoCircleIcon,
    EllipsisIcon,
    StarIcon,
    StarFilledIcon,
    createFolderDialog,
    renameFolderDialog,
    selectTargetFolder,
    dropdown,
    conflictDialog,
    errListDialog,
    AddFileAuth,
    CreateDocumentDialog,
    LinkShare,
    WemeetLinkShare,
    DropFile,
    SelectFilePath,
    pullUpLoading,
    Menu,
    MenuItem,
    Breadcrumb,
    FileCollectFormDialog,
    FileCollectResultDialog,
    FunctionBox,
    SelectFolder,
  },
  beforeRouteLeave(to: Route, from: Route, next: Function) {
    next();
  },
  setup(props, context) {
    // 解构 props
    const { spaceId, teamId, isPullListOnSetup, isCospace } = toRefs(props);
    // 当前文件类型
    const fileType = ref('dir');
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    // 获取当前组件所有的ref
    const currRef: Record<string, any> = currComponent.refs;
    const showUploadGuide = ref(false);
    const showCheckFileGuide = ref(false);
    const showShareGuide = ref(false);
    const showRefreshTips = ref(false);
    const showSeparateTips = ref(false);
    const spaceHintTips = ref(IS_PRIVATE ? i18n_t('(共享组织剩余空间)') : i18n_t('(共享企业剩余空间)'));

    const {
      columns,
      currPath,
      loading: loadingList,
      loadingOnHeader,
      tableData,
      pageData,
      sort,
      isSyncFolder,
      methods: listMethods,
    } = listHandler(spaceId);

    const resizeColumns = ref(setResizableColumns(columns.value));

    // TODO: 在tdesign的table组件增加重新计算列宽的方法之前，先用tricky-way实现需求，后面需要优化。
    // 用于触发重新计算列宽
    let resizeFlag = true;
    // 刷新columns配置
    const onWinResize = debounce(() => {
      const [firstCol] = columns.value;
      if (firstCol) {
        firstCol.width += resizeFlag ? 0.00001 : -0.00001;
        resizeFlag = !resizeFlag;
      }
    }, 300);
    const {
      operateShowMap,
      isActionFromMoreBtn,
      isFirstButtonHover,
      isSecondButtonHover,
      hoverIndex,
      isDropdownShow,
      methods: listOperateMethods,
      isShowMask,
      maskWidth,
      maskHeight,
      maskLeft,
      maskTop,
      moveFileTask,
      isDragging,
      droppableStatus,
    } = listOperateHandler(tableData, true);
    const { fileColleDialogMethods, fileCollectDialog } = fileCollectDialogHandler();

    const { buildTeam, functionBoxMode } = useFunctionBox();

    dynamicOpenHandler(spaceId);

    const {
      shouldShowFoldSelector,
      foldSelectorConfig,
      foldSelectorLocalPath,
      foldSelectorRemotePathContext,
      isFoldSelectorCreateBaseLocal,
      methods: selectFolderMethods,
    } = useSelectFolderHandler();

    const router = context.root.$router;
    const { query, meta, params } = router.currentRoute;
    const routeName = computed(() => vm.$route.name as string);
    const selectedIndex = ref(0);
    const requestPermissionVisible = ref(false);

    const crumbsRoot = ref<string | string[]>(i18n_t('根目录'));
    let queryName = '';
    switch (routeName.value) {
      case 'relatedToMeFileList':
        crumbsRoot.value = i18n_t('与我相关');
        break;
      case 'collaborationSpaceList':
        queryName = (query?.name as string) || i18n_t('根目录');
        crumbsRoot.value = [i18n_t('协作空间'), queryName];
        break;
      case 'favoriteList':
        crumbsRoot.value = i18n_t('我的收藏');
        break;
      case 'personalSpace':
        crumbsRoot.value = i18n_t('个人空间');
        break;
      default:
        if (meta?.name) {
          crumbsRoot.value = meta?.name;
        }
    }

    let startIndex = 0;
    if (['relatedToMeFileList', 'favoriteList'].includes(routeName.value)) {
      startIndex = Number(query?.startIndex) || 0;
    }
    const showOperationButton = computed(() => {
      const { selectedList } = tableData;
      return !store.getters.isInWeMeetApp || (store.getters.isInWeMeetApp && selectedList.length === 0);
    });
    const handledCrumbs = computed<CrumbItem[]>(() => {
      const rootCrumbs = Array.isArray(crumbsRoot.value) ? crumbsRoot.value : [crumbsRoot.value];
      const rootCrumbsWithPath = rootCrumbs.map(it => ({
        dir: it,
        path: '',
      }));
      const tableCrumbs = tableData.crumbs;
      const tableCrumbsWithPath = tableCrumbs.map((it, index) => ({
        dir: it,
        path: tableCrumbs.slice(0, index + 1).join('/'),
      }));
      let c: {
        dir: string;
        path?: string;
      }[] = [...rootCrumbsWithPath, ...tableCrumbsWithPath];
      if (routeName.value === 'relatedToMeFileList' || routeName.value === 'favoriteList') {
        if (startIndex + 1 === c.length) {
          c = [c[0], ...c.splice(-1)];
        } else if (c.length > 4 && c.length <= 6) {
          c.splice(1, c.length - 3);
        } else if (c.length > 6) {
          c = [
            c[0],
            c[startIndex],
            ...[
              {
                dir: '...',
              },
            ],

            ...c.splice(-1),
          ];
        }
      } else if (c.length > 4) {
        c = [
          c[0],
          c[1],
          ...[
            {
              dir: '...',
            },
          ],

          ...c.splice(-1),
        ];
      }
      return c.map(p => ({
        name: p.dir === crumbsRoot.value ? '' : p.dir,
        content: p.dir,
        type: 'dir',
        path: p.path,
        disabled: isDragging.value && (p.path === undefined || p.path === currPath.value), // 正在拖动 && (不是文件夹 || 不是当前文件夹)
      }));
    });

    const ableInviteOperate = computed(() => !!params.isOwner && handledCrumbs.value.length === 2); // 协作群组中是群主且在根目录下，则可邀请成员

    const isRootDir = computed(() => handledCrumbs.value.length === 2); // 是否在根目录下

    watch(
      isRootDir,
      val => {
        // 若当前为协作空间且不在根目录下，则不展示成员管理
        context.emit('showMemberManage', !(!val && routeName.value === 'collaborationSpaceList'));
      },
      {
        immediate: true,
      },
    );

    // 个人空间以及与我相关带spaceTag判断
    const noDisableRoleSelect = computed(
      () => vm.$route.query?.spaceTag === 'personal' || routeName.value === 'personalSpace',
    );

    const { methods: deleteMethods } = deleteHandler(spaceId);
    const { methods: uploadMethods } = uploadHandler();
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { show: showDetail, methods: detailMethods } = detailHandler(spaceId);
    const { show: showLink, showWemeetShare, linkData, methods: linkShareMethods } = linkShareHandler(spaceId);
    const { methods: extraFileInfoMethods } = extraFileInfoHandler(spaceId);
    const { showLoading, showFail, methods: downloadCodeMethods } = downloadCodeHandler();
    const currentUser = computed(() => context.root.$store.getters.userBaseInfo);
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const { methods: guideStepMethods } = guideStepHandler();
    const {
      showCreateFolder,
      showCreateDocument,
      showCreateStencil,
      createDocumentType,
      methods: createMethods,
    } = createHandler(spaceId);
    const {
      show: showRename,
      originName: fromName,
      type: renameType,
      methods: renameMethods,
      renameError,
    } = renameHandler(spaceId);
    const { show: showMoveTarget, methods: moveMethods } = moveHandler(spaceId);
    const { show: showCopyTarget, methods: copyMethods } = copyHandler(spaceId);
    const { show: showAuth, authParams, methods: authMethods } = authHandler(spaceId);
    const { methods: previewMethods } = openPreviewHandler(spaceId);
    const { methods: searchMethods } = searchHandler();
    const { filterMethods, actionMethods } = actionHandler();
    const {
      capacity,
      size,
      avaliableSpaceSize,
      quotaLimited,
      message,
      linkName,
      isSharedSpaceSize,
      methods: spaceQuotaMethods,
    } = spaceQuotaHandler(teamId);
    const isShowActionUI = (action: any, item: any): boolean => {
      if (tableData.selectedList.length === 1) {
        return optAuth(action, item);
      }
      return false;
    };
    const showInviteInWemeet = computed(() => {
      const { isInWeMeetApp } = store.getters;
      return (
        isInWeMeetApp && tableData.selectedList.length === 1 && isShowActionUI('Preview', tableData.selectedList[0])
      );
    });
    const SetListFocus = () => {
      currRef.filePageRef.focus({
        preventScroll: true,
      });
    };
    const onDropdownVisibleChange = (visible: boolean) => {
      if (
        !visible &&
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length <= 0
      ) {
        SetListFocus();
      }
    };

    const methods = {
      async onOperateEventProxy(command: string, selectItem?: SMH.SpaceFileItemData, btnLocation?: string) {
        const selectedList = selectItem ? [selectItem] : tableData.selectedList; // 多选列表字段，保证一定列表中有值
        const item = selectedList[0]; // 单选操作项字段
        fileType.value = item && item.type;
        // 企业空间下上报当前部门名称/协作空间下上报群组名称
        let department_name = '';
        if (vm.$route.name === 'teamSpace') {
          const teamPath = vm.$route?.query?.teamPath as string;
          department_name = teamPath ? teamPath.split('/').reverse()[0] : '';
        } else if (vm.$route.name === 'collaborationSpaceList') {
          department_name = vm.$route?.query?.name as string;
        }
        reporter.report('file_actions', {
          command,
          file_name: item?.name || '',
          space_module: vm.$route.name,
          department_name,
        });

        let spaceTag: SpaceTag | null = null;
        if (vm.$route.name === 'teamSpace') spaceTag = SpaceTag.team;
        if (vm.$route.name === 'personalSpace') spaceTag = SpaceTag.personal;
        if (vm.$route.name === 'collaborationSpace') spaceTag = SpaceTag.group;

        switch (command) {
          case 'create_folder':
            createMethods.openCreateFolder();
            break;
          case 'create_word':
          case 'create_excel':
          case 'create_ppt':
            createMethods.openCreateDocument(command);
            break;
          case 'create_stencil':
            createMethods.openCreateStencil();
            break;
          case 'open':
            if (item.type === 'dir') {
              // 进入文件夹后重置当前页为默认值;
              listMethods.changeCurrentPath(item.name, 'add');
              // TODO logan reset drawer
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持在线预览'));
            } else if (!can('Preview', item)) {
              tips.error(i18n_t('暂无在线预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && +item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              if (vm.$route.name === 'personalSpace') {
                // 查看新手引导是否有对应数据，如果没有，对其进行对应分享相关的更新
                guideStepMethods.monitoringStepsDone('personalSpace', 1);
              }
              // 计算preview页面的数据加载需要从第几页加载，preview默认pageSize为10条
              const { currPage } = pageData;
              // const previewPage = Math.ceil(((currPage - 1) * pageSize + index + 1) / ConstantConfig.previewPageSize);
              storage.set(storage.StoreKey.IMG_PREVIEW_LIST, {
                ...sort,
                ...pageData,
              });
              previewMethods.openPreview(item, currPage, {
                teamId: teamId.value,
                sort,
                showList: true,
                spaceTag: (vm.$route.query?.spaceTag as string) || '',
              });
            }
            break;
          case 'delete':
            {
              const deleteData = selectedList;
              deleteMethods.confirmDelete(deleteData, false, () => {
                SetListFocus();
              });
              reporter.report('delete', {
                delete_location: routeName.value,
              });
            }
            break;
          case 'upload_folder':
          case 'upload_file':
          case 'upload_files':
            // eslint-disable-next-line no-case-declarations
            const [, type] = command.split('_');
            uploadMethods.openSelection(type, currPath.value, spaceId.value);
            break;
          case 'download':
            {
              const downloadData = selectedList;
              const params = downloadData.map(o => ({
                userId: +o.userId,
                virusAuditStatus: o.virusAuditStatus as number,
                sensitiveWordAuditStatus: o.sensitiveWordAuditStatus as number,
              }));
              if (!checkVirusStatus(params, 'download')) return;
              // web支持批量下载，不拉起pc
              downloadMethods.prepareDownload(downloadData);
              SetListFocus();
            }
            break;
          case 'rename':
            renameMethods.openRenameFolder(item);
            break;
          case 'detail':
          case 'history':
            tableData.selectedRowKeys = [item.id];
            tableData.selectedList = [item];
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_SHOW_DETAIL, command);
            break;
          case 'move':
            {
              const moveData = selectedList;
              moveMethods.openSelectFolder(moveData);
            }
            break;
          case 'copy':
            {
              const copyData = selectedList;
              copyMethods.openSelectFolder(copyData);
            }
            break;
          case 'refresh':
            listMethods.refresh();
            break;
          case 'auth':
            {
              if (checkIfMobileStyle()) return;
              const path = item.path.join('/');
              const _teamId = vm.$route.query?.teamId;
              const teamId = _teamId ? +_teamId : undefined;
              const params = {
                userId: item.userId,
                virusAuditStatus: item.virusAuditStatus,
                spaceTag: item.spaceTag || spaceTag,
                path,
                teamId,
              };
              const canOpenAuthDialog = authMethods.canOpenAuthDir(params);
              if (!canOpenAuthDialog) return;
              Object.assign(authParams, { params });
              showAuth.value = true;
              reporter.report('authorization', {
                auth_location: routeName.value,
              });
            }
            break;
          case 'preview':
            if (isAllowPreviewImage(item.name) && +item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              // 计算preview页面的数据加载需要从第几页加载，preview默认pageSize为10条
              const { currPage } = pageData;
              // const previewPage = Math.ceil(((currPage - 1) * pageSize + index + 1) / ConstantConfig.previewPageSize);
              storage.set(storage.StoreKey.IMG_PREVIEW_LIST, {
                ...sort,
                ...pageData,
              });
              previewMethods.openPreview(item, currPage, {
                teamId: teamId.value,
                sort,
                showList: true,
              });
            }
            break;
          case 'edit':
            if (!item.authorityList?.canModify) {
              tips.error(i18n_t('暂无权限，请联系管理员'));
            } else {
              await previewMethods.openEdit(item, sort, true);
            }
            break;
          case 'share':
            {
              const shareData = selectedList;
              const params = shareData.map(o => ({
                userId: +o.userId,
                virusAuditStatus: o.virusAuditStatus as number,
                sensitiveWordAuditStatus: o.sensitiveWordAuditStatus as number,
              }));
              if (!checkVirusStatus(params, 'share')) return;
              if (shareData.length === 1 && store.getters.isInWeMeetApp) {
                const { preview, edit } = methods.getFileOrDirPermission(shareData[0]);
                shareData[0] = {
                  ...shareData[0],
                  canPreview: preview,
                  canEdit: edit,
                };
              }
              linkShareMethods.openShare(shareData);
            }
            break;
          case 'addFavorite':
            extraFileInfoMethods.addFavorite(item, tableData.list);
            reporter.report('collect', {
              collect_location: LOCATION_MAP[routeName.value],
            });
            break;
          case 'delFavorite':
            extraFileInfoMethods.delFavorite([item.favoriteId], tableData.list);
            reporter.report('collect', {
              collect_location: LOCATION_MAP[routeName.value],
            });
            break;
          case 'sync':
            {
              if (!spaceTag || spaceTag === SpaceTag.group) break;

              const spaceOrgId = item.spaceOrgId ?? +(vm.$route.query?.spaceOrgId || store.getters.orgId);

              const path = item.path.join('/');
              const remotePathContext: SyncSelectFolder.RemotePathContext = {
                remotePath: path,
                spaceTag,
                spaceId: spaceId.value,
                spaceOrgId,
                teamId: teamId.value,
                teamPath: (vm.$route.query.teamPath as string) ?? '',
              };
              selectFolderMethods.showCreateDialogWithRemotePath(
                remotePathContext,
                ShowConfigDialogSource.RemoteButtonInRightClickMenu,
              );
            }
            break;
          case 'invite_to_preview':
          case 'invite_to_edit': {
            const [, , action] = command.split('_');
            wemeetingMethods.share(action, {
              ...item,
              spaceId: spaceId.value,
              btnLocation,
            });
            break;
          }
          case 'esign': {
            previewMethods.openPreview(item, 1, {
              esign: true,
              sort,
              showList: true,
            });
            break;
          }
          case 'fileCollect': {
            // h5页面暂未适配文件收集功能
            if (checkIfMobileStyle()) return;
            const currentSpaceId = spaceId.value || (await spaceATM.getPersonalSpaceIdAsync());
            fileColleDialogMethods.openFileCollectFormDialog(selectedList, {
              spaceId: currentSpaceId,
            });
            reporter.report('task_start', {
              start_way: 'folder',
            });
            break;
          }
          case 'requestPermission':
            requestPermissionVisible.value = true;
            break;
          default:
            break;
        }
      },
      refreshSpaceQuota() {
        if (vm.$route.name === 'personalSpace') {
          spaceQuotaMethods.getPeronalSpaceQuota();
        } else if (vm.$route.name === 'teamSpace') {
          spaceQuotaMethods.getTeamSpaceQuota();
        }
      },
      refreshList(data?: Array<SMH.SpaceFileItemData>, action?: string) {
        // refresh会进行total更新
        listMethods.refresh();
        // 刷新列表时也刷新一下空间使用情况
        methods.refreshSpaceQuota();
      },
      silentRefresh() {
        showRefreshTips.value = false;
        listMethods.silentRefresh();
        // 刷新列表时也刷新一下空间使用情况
        methods.refreshSpaceQuota();
      },
      /**
       * 获取文件或者文件夹的权限列表
       * @param item 聚焦的item，不一定是selectedList的第0位
       * @param isContextMenu
       */
      getFileOrDirPermission(item: SMH.SpaceFileItemData, isContextMenu?: boolean): Record<string, boolean> {
        const { isMobileStyle, isMobile, isInWeMeetApp, editionFlag, isPrivate } = store.getters;
        let actionMap: Record<string, boolean>;
        const canShare = can('Share', item);
        const canPreview = item.type !== 'dir' && optAuth('Preview', item);
        const canEdit = item.type !== 'dir' && optAuth('Edit', item) && !quotaLimited.value;
        const canFileCollect =
          can('Upload', item) && item.type === 'dir' && routeName.value !== 'collaborationSpaceList';
        // 管理员
        const canRequestPermission = true;
        actionMap = {
          share: canShare && !isActionFromMoreBtn.value,
          addFavorite: !item.favorited,
          delFavorite: item.favorited,
          rename: can('Modify', item) || (can('Delete', item) && can('Download', item) && can('Upload', tableData)),
          move: can('Delete', item) && can('Download', item),
          copy: can('Download', item),
          auth: editionFlag === 'enterprise' && can('Authorize', item) && !isCospace.value,
          sync: !IS_BROWSER && optAuth('Sync', item) && ['teamSpace', 'personalSpace'].includes(vm.$route.name ?? ''),
          delete: can('Delete', item),
          preview: canPreview,
          edit: canEdit,
          esign: optAuth('Esign', item) && !isPrivate,
          // 非移动端界面不给 详情、历史版本、下载入口
          detail: isMobileStyle && can('View', item),
          history: isMobileStyle && item.type !== 'dir',
          // 文件收集 & 且是有上传权限的文件夹
          fileCollect: canFileCollect,
          requestPermission: canRequestPermission,
          // 移动端腾讯会议不给下载入口, WEB端展示下载入口
          download:
            optAuth('Download', item) && (!isInWeMeetApp || (isInWeMeetApp && !isMobile)) && !isActionFromMoreBtn.value,
          // 腾讯会议中才展示
          invite_to_preview: isInWeMeetApp && canShare && canPreview,
          invite_to_edit: isInWeMeetApp && canShare && canEdit,
        };
        actionMap = filterMethods.filterAll(actionMap, item);
        return actionMap;
      },
      /**
       * 获取按钮列表 options
       * @description
       * 场景：
       * 1. 计算表格中【更多】按钮的 下拉菜单项 options
       * 2. 计算表格中右键后的菜单选项 options
       * 3. 计算表格中 [下载][分享][...]中的更多选项options
       * 需要留意的是，场景1与场景3中的数据应当是一致的
       *
       *
       * 函数流程：
       * 1. 会首先根据参数计算得到actionMap
       * 2. 对多选时的情况进行交集计算，得到公共权限
       * 3. 对不支持多选的功能进行过滤（例如收藏不支持多选）
       * 4. 根据actionMap进行计算得到options进行返回
       *
       * @param item
       * @param isContextMenu 若为true，则是右键菜单。若为false，则是更多菜单
       * @return options {Array<{ content: string; value: string }>}
       */
      renderDropdownItemOptions(item: SMH.SpaceFileItemData, isContextMenu?: boolean) {
        const selectedSize = tableData.selectedList.length;
        let actionMap: Record<string, boolean> = {};
        // 单选的时候直接进行计算(若未选中，也就是size===0的时候，需要根据当前聚焦的item来进行计算）
        if (selectedSize <= 1) {
          actionMap = methods.getFileOrDirPermission(item, isContextMenu);
        }
        // 多选的时候，需要进行交集计算，还要进行过滤
        if (selectedSize > 1) {
          actionMap = methods.calcIntersectionPermission(tableData.selectedList);
        }
        return actionMethods.calcOptionsByActionMap(actionMap);
      },
      /**
       * 获取快捷键（组合)信息
       * @param itemValue
       */
      GetDropdownItemShortCutText(itemValue: string) {
        const textArray = hotkeyDataHelper.getHotKeyTextArrayFromAction(itemValue);
        if (textArray.length === 0) {
          return '';
        }
        return textArray.join('+');
      },
      /**
       * 计算得到多选时，权限的交集actionMap
       * @param selectedList
       */
      calcIntersectionPermission(selectedList: Array<SMH.SpaceFileItemData>) {
        // 多个不同选中文件中，共有的权限集合
        let intersectionActionMap = {};
        const { intersection, clear } = actionMethods.calcActionRecord();
        clear();
        //  计算不同item文件对应的交集权限
        selectedList.forEach((selected: SMH.SpaceFileItemData, index: number) => {
          const actionByMap: Record<string, boolean> = methods.getFileOrDirPermission(selected, true);
          intersectionActionMap = intersection(actionByMap, index);
        });
        // 过滤掉不支持多选的权限
        intersectionActionMap = filterMethods.multiFilter(intersectionActionMap);
        return intersectionActionMap;
      },

      async onAuthSaved(isSuccess: boolean) {
        if (isSuccess) {
          listMethods.refresh();
        }
      },
      // 此处添加的目的：考虑动态处文件夹的跳转
      replaceCurrentPath() {
        listMethods.changeCurrentPath(vm.$route.query?.path as string, 'replace');
      },

      canShow(act: operateType, item: SMH.SpaceFileItemData) {
        if (act === 'Share' && props.isExternGroup) {
          return true;
        }
        return can(act, item);
      },

      enableButton(act: operateType) {
        if (act === 'Share' && props.isExternGroup) {
          return false;
        }
        return true;
      },
    };

    // 个人空间才需要立即初始化列表
    if (isPullListOnSetup.value) {
      listMethods.pullList().then(() => {
        // methods.updateDrawer(tableData.selectedList);
      });
      if (vm.$route.name === 'personalSpace') spaceQuotaMethods.getPeronalSpaceQuota();
    }
    const guideTipsShow = (val: string) => {
      let target = null;
      switch (val) {
        case 'showUploadGuide':
          showUploadGuide.value = true;
          reporter.report('upload_guide', {
            guide_detail: 'show',
          });
          setTimeout(() => {
            showUploadGuide.value = false;
          }, 3000);
          break;
        case 'showCheckFileGuide':
          showCheckFileGuide.value = true;
          reporter.report('check_guide', {
            guide_detail: 'show',
          });
          // 如果没有文件就不走后面的
          if (tableData.list.length === 0) return;
          // 默认自动选中第一个可预览的文件
          for (let i = 0; i < tableData.list.length; i++) {
            if (tableData.list[i]?.type !== 'dir' && !noPreview(tableData.list[i])) {
              tableData.selectedList = [tableData.list[i]];
              tableData.selectedRowKeys = [tableData.list[i].id];
              target = document.getElementById(tableData.list[i].id);
              selectedIndex.value = i;
              break;
            }
          }
          if (selectedIndex.value > 5) {
            try {
              // 兼容浏览器不支持scrollIntoViewIfNeeded的使用
              // @ts-ignore
              if (target && target.scrollIntoViewIfNeeded) {
                // @ts-ignore
                target && target.scrollIntoViewIfNeeded(true);
              } else {
                target && target.scrollIntoView(true);
              }
            } catch (error) {
              logger.ui.error('scrollIntoViewIfNeeded', error);
            }
          }
          setTimeout(() => {
            showCheckFileGuide.value = false;
          }, 3000);
          break;
        case 'showShareGuide':
          showShareGuide.value = true;
          reporter.report('share_guide', {
            guide_detail: 'show',
          });
          // 默认自动选中第一个文件
          // eslint-disable-next-line
          tableData.selectedList = [];
          tableData.selectedList.push(tableData.list[0]);
          tableData.selectedRowKeys = [tableData.list[0].id];
          setTimeout(() => {
            showShareGuide.value = false;
          }, 3000);
          break;
        default:
          break;
      }
    };
    watch(
      () => spaceId.value,
      () => {
        // 切换团队空间时要将详情重置
        detailMethods.reset();
        // 企业空间查询空间配额是否足够
        spaceQuotaMethods.getTeamSpaceQuota();
      },
    );

    // 监听路由地址改变
    watch(
      () => vm.$route,
      (val, old) => {
        // 若是teamPath发生了改变
        const newTeamPath = val.query.teamPath as string;
        if (newTeamPath !== old?.query.teamPath && !['relatedToMeFileList', 'favoriteList'].includes(routeName.value)) {
          crumbsRoot.value = newTeamPath.split('/').pop() as string;
          ipc.emit(
            ipc.RENDERER_EVENTS_MAP.TEAM_LIST_ACTIVEATE_BY_TEAMPATH,
            (val.query.teamPath as string)?.split('/'),
            {
              init: true,
            },
          );
        }
      },
      {
        immediate: true,
      },
    );

    watch(
      () => tableData.selectedList,
      (newList, oldList) => {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, unref(newList), unref(oldList));
        SetListFocus();
      },
    );

    // 监听drawer变化，自动调整表格列宽
    watch(() => store.getters.drawerShow, onWinResize);

    // 监听crumbs的变化 对应显示新的抽屉
    // watch(() => crumbs.value, (val => {
    //   methods.updateDrawer(tableData.selectedList);
    // }));
    const handleMouseMove = (event: MouseEvent) => {
      listOperateMethods.onMouseMoveEvent(event);
    };
    const handleMouseUp = (event: MouseEvent) => {
      listOperateMethods.onMouseUpEvent(event);
    };
    const handleMouseDown = (event: MouseEvent) => {
      listOperateMethods.onMouseDownEvent(event);
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
      ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_GET_SPACE_AUOTA, spaceQuotaMethods.getTeamSpaceQuota);
      ipc.on(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, guideTipsShow);
      ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH_SAPCE_QUOTA, methods.refreshSpaceQuota);
      ipc.on(ipc.RENDERER_EVENTS_MAP.REPLACE_CURRENT_PATH, methods.replaceCurrentPath);
      document.body.addEventListener('mousemove', handleMouseMove);
      document.body.addEventListener('mouseup', handleMouseUp);
      // 监听窗口尺寸变化，自动调整表格列宽
      window.addEventListener('resize', onWinResize);
    });
    onUnmounted(() => {
      document.body.removeEventListener('mousemove', handleMouseMove);
      document.body.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('resize', onWinResize);
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, methods.refreshList);
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_GET_SPACE_AUOTA, spaceQuotaMethods.getTeamSpaceQuota);
      ipc.off(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, guideTipsShow);
      ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH_SAPCE_QUOTA, methods.refreshSpaceQuota);
      ipc.off(ipc.RENDERER_EVENTS_MAP.REPLACE_CURRENT_PATH, methods.replaceCurrentPath);
    });
    const batchOperationsShow = computed(() => {
      const show = {
        preview: false,
        addFavorite: false,
        delFavorite: false,
        edit: false,
        auth: false,
        rename: false,
        move: false,
        copy: false,
        delete: false,
        share: false,
        fileCollect: false,
        requestPermission: false,
        // 腾讯会议中才需要判断
        inviteToPreview: false,
        inviteToEdit: false,
        sync: false,
      };
      if (tableData.selectedList.length === 1) {
        const [item] = tableData.selectedList;
        const allow = methods.getFileOrDirPermission(item);
        Object.assign(show, {
          preview: allow.preview,
          addFavorite: allow.addFavorite,
          delFavorite: allow.delFavorite,
          edit: allow.edit,
          auth: allow.auth,
          rename: allow.rename,
          move: allow.move,
          copy: allow.copy,
          delete: allow.delete,
          share: allow.share,
          fileCollect: allow.fileCollect,
          sync: allow.sync && item.type === 'dir',
          requestPermission: allow.requestPermission,
          // 以下为腾讯会议中展示的入口 （by wonder）
          inviteToPreview: allow.share && allow.preview && store.getters.isInWeMeetApp && item.type !== 'dir',
          inviteToEdit: allow.share && allow.edit && store.getters.isInWeMeetApp && item.type !== 'dir',
        });
      } else if (tableData.selectedList.length > 0) {
        const selected = tableData.selectedList;
        Object.assign(show, {
          move:
            vm.$route.name !== 'relatedToMeFileList' &&
            selected.every(item => item.authorityList?.canDelete && item.authorityList?.canDownload),
          copy: vm.$route.name !== 'relatedToMeFileList' && selected.every(item => item.authorityList?.canDownload),
          delete: selected.every(item => item.authorityList?.canDelete),
          share: store.getters.enableShare && selected.every(item => item.authorityList?.canShare),
          requestPermission: true,
        });
      }
      return filterMethods.filterAll(show, tableData.selectedList[0]);
    });

    // 下载
    const showDownload = computed<boolean>(
      () => vm.$store.getters.isInWeMeetApp && !vm.$store.getters.isMobile && tableData.selectedRowKeys.length === 1,
    );

    // 分享
    const showShare = computed<boolean>(() => vm.$store.getters.isMobileStyle && batchOperationsShow.value.share);
    // 在线预览
    const showPreview = computed<boolean>(() => batchOperationsShow.value.preview);
    // 收藏
    const showFavorite = computed<boolean>(() => batchOperationsShow.value.addFavorite);
    // 取消收藏
    const showDelFavorite = computed<boolean>(() => batchOperationsShow.value.delFavorite);
    // 在线编辑
    const showEdit = computed<boolean>(() => batchOperationsShow.value.edit);
    // 共享授权
    const showAuthBtn = computed<boolean>(() => batchOperationsShow.value.auth);
    // 重命名
    const showRenameBtn = computed<boolean>(() => batchOperationsShow.value.rename);
    const showDeleteBtn = computed<boolean>(() => batchOperationsShow.value.delete);
    // 移动到
    const showMoveBtn = computed<boolean>(() => batchOperationsShow.value.move);
    // 复制到
    const showCopyBtn = computed<boolean>(() => batchOperationsShow.value.move);
    //  权限申请
    const showRequestPermissionBtn = computed<boolean>(() => batchOperationsShow.value.requestPermission);
    // 是否有更多按钮
    const hasMoreBtns = computed<boolean>(
      () =>
        showDownload.value ||
        showShare.value ||
        showPreview.value ||
        showDeleteBtn.value ||
        showDelFavorite.value ||
        showFavorite.value ||
        showEdit.value ||
        showAuthBtn.value ||
        showRenameBtn.value ||
        showMoveBtn.value ||
        showCopyBtn.value ||
        showRequestPermissionBtn.value,
    );

    const TableHoverClass = computed<string>((): string => {
      switch (droppableStatus.value) {
        case DroppableStatus.Droppable:
          // 拖拽过程中，可以移动文件的目标
          return 't-table-hover-dragging-droppable';
        case DroppableStatus.FileTypeNotDroppable: // 非文件夹不可以作为target
        case DroppableStatus.DraggingFileNotDroppable:
          // 正在拖动的文件不可以作为target
          return 't-table-hover-dragging-undroppable';
        case DroppableStatus.NotDragging:
          // 目前没有在拖拽
          return 't-table-hover-normal';
        default:
          return 't-table-hover-normal';
      }
    });
    const fileListCopyData = computed(() => ({
      spaceId: vm.$store.state.fileListCopy.spaceId,
      fileList: vm.$store.state.fileListCopy.fileList,
      type: vm.$store.state.fileListCopy.type,
    }));
    const handleMenuClick = (action: string, btnLocation?: string): void => {
      if (tableData.selectedRowKeys.length === 1) {
        methods.onOperateEventProxy(action, tableData.selectedList[0], btnLocation);
      } else {
        methods.onOperateEventProxy(action, undefined, btnLocation);
      }
    };
    const handleHotKeyAction = (action: string): boolean => {
      // 过滤t-dialog弹窗打开的情况
      if (
        loadingList.value ||
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length > 0
      ) {
        return false;
      }
      switch (action) {
        case 'rename':
          if (tableData.selectedRowKeys.length === 1 && showRenameBtn.value) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'open':
          if (tableData.selectedRowKeys.length === 1) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'download':
          if (canBatch('Download', tableData.selectedList)) {
            methods.onOperateEventProxy(action);
            return true;
          }
          break;
        case 'move':
          if (tableData.selectedRowKeys.length > 0 && showMoveBtn.value) {
            methods.onOperateEventProxy(action);
            return true;
          }
          break;
        case 'share':
          if (tableData.selectedRowKeys.length > 0 && batchOperationsShow.value.share) {
            methods.onOperateEventProxy(action);
            return true;
          }
          break;
        case 'selectAll':
          if (tableData.list.length > 0) {
            tableData.selectedRowKeys = [];
            tableData.selectedList = [];
            for (let i = 0; i < tableData.list.length; i++) {
              tableData.selectedRowKeys.push(i);
              tableData.selectedList.push(tableData.list[i]);
            }
            return true;
          }
          break;
        case 'addFavorite':
        case 'delFavorite':
          if (tableData.selectedRowKeys.length === 1) {
            if (showFavorite.value) {
              methods.onOperateEventProxy('addFavorite', tableData.selectedList[0]);
              return true;
            }
            if (showDelFavorite.value) {
              methods.onOperateEventProxy('delFavorite', tableData.selectedList[0]);
              return true;
            }
          }
          break;
        case 'search':
          searchMethods.openSearch({
            keyword: '',
            scope: 'all',
          });
          return true;
        case 'delete':
          if (tableData.selectedRowKeys.length > 0 && showDeleteBtn.value) {
            methods.onOperateEventProxy('delete');
            return true;
          }
          break;
        case 'copy':
          if (tableData.selectedRowKeys.length > 0 && showCopyBtn.value) {
            store.commit('SET_FILE_LIST_COPY_DATA', {
              spaceId: spaceId.value,
              fileList: tableData.selectedList,
              type: 'copy',
            });
            tips.info(
              i18n_t('已将{slot1}个项目复制剪贴板', {
                slot1: tableData.selectedRowKeys.length,
              }),
            );

            return true;
          }
          break;
        case 'paste':
          if (fileListCopyData.value.fileList.length > 0) {
            if (fileListCopyData.value.spaceId === spaceId.value) {
              copyMethods.onHotKeyCopy({
                path: currPath.value,
                orgSpaceId: fileListCopyData.value.spaceId,
                dstSpaceId: '',
                fileList: fileListCopyData.value.fileList,
              });
            } else {
              tips.error(i18n_t('暂不支持跨空间或群组复制'));
            }
            return true;
          }
          break;
        case 'uploadFile':
          if (can('Upload', tableData) && !quotaLimited.value) {
            methods.onOperateEventProxy('upload_file');
            return true;
          }
          break;
        case 'uploadFolder':
          if (can('Upload', tableData) && !quotaLimited.value) {
            methods.onOperateEventProxy('upload_folder');
            return true;
          }
          break;
        case 'Escape':
          listOperateMethods.handleEscClick();
          return true;
        default:
          break;
      }

      return false;
    };
    watch(
      () => moveFileTask.value,
      newTask => {
        const { sourceFile, moveToPath } = newTask;
        moveMethods.setupFileSource(sourceFile);
        moveMethods.onMove(ref(moveToPath));
      },
    );

    watch(
      () => dragFileHandler.draggingRowKeys.value,
      newDraggingRowKeys => {
        listMethods.updateDisabledRowKeys(newDraggingRowKeys);
      },
    );

    watch(
      () => [
        showWemeetShare.value,
        showAuth.value,
        showMoveTarget.value,
        showRename.value,
        showLink.value,
        showCreateFolder.value,
        showCreateDocument.value,
        showCreateStencil.value,
      ],

      () => {
        if (
          !showWemeetShare.value &&
          !showAuth.value &&
          !showMoveTarget.value &&
          !showRename.value &&
          !showLink.value &&
          !showCreateFolder.value &&
          !showCreateDocument.value &&
          !showCreateStencil.value
        ) {
          SetListFocus();
        }
      },
    );

    return {
      capacity,
      size,
      avaliableSpaceSize,
      quotaLimited,
      message,
      linkName,
      isSharedSpaceSize,
      ConstantConfig,
      hasMoreBtns,
      resizeColumns,
      loadingList,
      loadingOnHeader,
      tableData,
      pageData,
      isSyncFolder,
      operateShowMap,
      isDropdownShow,
      isActionFromMoreBtn,
      isFirstButtonHover,
      isSecondButtonHover,
      selectedIndex,
      hoverIndex,
      listOperateMethods,
      ...toRefs(tableData),
      ...toRefs(pageData),
      handledCrumbs,
      listMethods,
      fileType,
      currPath,
      ableInviteOperate,
      noDisableRoleSelect,
      requestPermissionVisible,
      uploadMethods,
      showCreateFolder,
      showCreateDocument,
      showCreateStencil,
      createDocumentType,
      showRename,
      renameType,
      fromName,
      createMethods,
      renameMethods,
      deleteMethods,
      moveMethods,
      copyMethods,
      searchMethods,
      showDetail,
      showMoveTarget,
      showCopyTarget,
      showInviteInWemeet,
      onOperateEventProxy: methods.onOperateEventProxy,
      sort,
      renameError,

      showAuth,
      authParams,
      authMethods,

      can,
      canBatch,
      optAuth,
      batchOperationsShow,
      startIndex,
      renderDropdownItemOptions: methods.renderDropdownItemOptions,
      GetDropdownItemShortCutText,
      showLink,
      showWemeetShare,
      linkData,
      onRefresh: methods.refreshList,
      silentRefresh: methods.silentRefresh,
      showLoading,
      showFail,
      downloadCodeMethods,
      showUploadGuide,
      showCheckFileGuide,
      showShareGuide,
      showRefreshTips,
      showSeparateTips,
      routeName,
      getFileOrDirPermission: methods.getFileOrDirPermission,
      onAuthSaved: methods.onAuthSaved,
      handleMouseDown,
      handleMouseMove,
      handleMouseUp,

      canShow: methods.canShow,
      enableButton: methods.enableButton,

      isShowMask,
      maskWidth,
      maskHeight,
      maskLeft,
      maskTop,
      handleMenuClick,
      isShowActionUI,
      TableHoverClass,
      isDragging,
      handleHotKeyAction,
      fileListCopyData,
      onDropdownVisibleChange,
      fileCollectDialog,
      fileColleDialogMethods,

      showOperationButton,
      buildTeam,
      functionBoxMode,

      spaceHintTips,

      shouldShowFoldSelector,
      foldSelectorConfig,
      foldSelectorLocalPath,
      foldSelectorRemotePathContext,
      isFoldSelectorCreateBaseLocal,
    };
  },
});
